export default __webpack_public_path__ + "static/media/640_portfolio03-fr-web.83ffd8af.png";